import { useQuery } from "@tanstack/react-query";
import { TeamInfoResponse } from "interfaces";
import { getTeamInfoService } from "services";

export const useGetTeamInfo = (enabled: boolean = true) => {
  return useQuery<TeamInfoResponse>({
    queryKey: ["team-info"],
    queryFn: () => getTeamInfoService(),
    enabled,
  });
};
